import React, { useState } from "react";
import { Accordion, Button } from "react-bootstrap";

// img
import { ReactComponent as CloseBtn } from "../../../Assets/Images/icn/close.svg";

import logo from "../../../Assets/Images/logo.png";
import { Link, NavLink } from "react-router-dom";

import "./Sidebar.scss";

const Sidebar = ({ showSidebar, setSidebar }) => {
  const handleSidebar = () => {
    setSidebar(!showSidebar);
  };
  return (
    <>
      <div
        className={`sidebar GuideSidebar py-2 pt-4 ${showSidebar && "active"}`}
      >
        <Button
          onClick={handleSidebar}
          className="border-0 p-0 position-absolute closeBtn rounded-0 d-flex align-items-center justify-content-center d-lg-none"
          variant="transparent"
          style={{ right: "0", top: "0" }}
        >
          <CloseBtn />
        </Button>
        <div className="top pb-3 mb-2 px-3 text-center border-bottom border-secondary">
          <Link to={"/"} className="text-dark logo">
            <img src={logo} alt="" className="img-fluid" />
          </Link>
        </div>
        <Accordion>
          <div className="LinksWrpper">
            <h6 className="m-0 text-white fw-bold px-2">Articles & Guide</h6>
            <ul className="list-unstyled ps-0 mb-0 pt-3">
              <li className="">
                <NavLink
                  to="/help/create-account"
                  className="text-white w-100 px-2 py-2 d-flex align-items-center"
                >
                  <span className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4ZM12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Create an Account
                </NavLink>
              </li>
              <li className="">
                <NavLink
                  to="/help/add-first-client"
                  className="text-white w-100 px-2 py-2 d-flex align-items-center"
                >
                  <span className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_10_6)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.918 1.623C12.918 1.83614 12.876 2.04718 12.7945 2.2441C12.7129 2.44101 12.5933 2.61992 12.4426 2.77063C12.2919 2.92134 12.113 3.04089 11.9161 3.12246C11.7192 3.20402 11.5081 3.246 11.295 3.246C11.0819 3.246 10.8708 3.20402 10.6739 3.12246C10.477 3.04089 10.2981 2.92134 10.1474 2.77063C9.99666 2.61992 9.87711 2.44101 9.79554 2.2441C9.71398 2.04718 9.672 1.83614 9.672 1.623C9.672 1.19255 9.84299 0.779737 10.1474 0.475366C10.4517 0.170994 10.8646 0 11.295 0C11.7254 0 12.1383 0.170994 12.4426 0.475366C12.747 0.779737 12.918 1.19255 12.918 1.623ZM13.942 6.66C13.9047 6.82632 13.8119 6.97498 13.6789 7.0815C13.5458 7.18801 13.3804 7.24603 13.21 7.246H7.098C6.89909 7.246 6.70832 7.16698 6.56767 7.02633C6.42702 6.88568 6.348 6.69491 6.348 6.496C6.348 6.29709 6.42702 6.10632 6.56767 5.96567C6.70832 5.82502 6.89909 5.746 7.098 5.746H8.694C8.87465 5.11972 9.27528 4.57969 9.82226 4.22518C10.3692 3.87067 11.0258 3.72551 11.6712 3.81638C12.3167 3.90725 12.9077 4.22804 13.3355 4.71979C13.7633 5.21153 13.9993 5.84119 14 6.493C14 6.5536 13.9795 6.61242 13.942 6.66ZM1.359 3.324C1.359 3.80431 1.5498 4.26494 1.88943 4.60457C2.22906 4.9442 2.68969 5.135 3.17 5.135C3.65031 5.135 4.11094 4.9442 4.45057 4.60457C4.7902 4.26494 4.981 3.80431 4.981 3.324C4.981 2.84369 4.7902 2.38306 4.45057 2.04343C4.11094 1.7038 3.65031 1.513 3.17 1.513C2.68969 1.513 2.22906 1.7038 1.88943 2.04343C1.5498 2.38306 1.359 2.84369 1.359 3.324ZM0 9.019C-6.20321e-09 8.60271 0.0819945 8.1905 0.241302 7.80589C0.400609 7.42129 0.63411 7.07183 0.928472 6.77747C1.22283 6.48311 1.57229 6.24961 1.95689 6.0903C2.3415 5.93099 2.75371 5.849 3.17 5.849C3.58629 5.849 3.9985 5.93099 4.38311 6.0903C4.76771 6.24961 5.11717 6.48311 5.41153 6.77747C5.70589 7.07183 5.93939 7.42129 6.0987 7.80589C6.25801 8.1905 6.34 8.60271 6.34 9.019V9.877C6.34 10.0096 6.28732 10.1368 6.19355 10.2306C6.09979 10.3243 5.97261 10.377 5.84 10.377H4.98L4.582 13.562C4.56689 13.6829 4.50815 13.7941 4.41682 13.8748C4.32549 13.9554 4.20785 14 4.086 14H2.253C2.13115 14 2.01351 13.9554 1.92218 13.8748C1.83085 13.7941 1.77211 13.6829 1.757 13.562L1.358 10.377H0.5C0.367392 10.377 0.240215 10.3243 0.146447 10.2306C0.0526784 10.1368 0 10.0096 0 9.877V9.019Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_10_6">
                          <rect width="14" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Adding Your First Client
                </NavLink>
              </li>
              <li className="">
                <NavLink
                  to="/help/direct-link-client"
                  className="text-white w-100 px-2 py-2 d-flex align-items-center"
                >
                  <span className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M17.7399 2.76001C18.547 3.56991 19.0001 4.66666 19.0001 5.81001C19.0001 6.95336 18.547 8.05011 17.7399 8.86001L16.2099 10.38C15.0899 11.5 13.5099 11.85 12.0699 11.47L14.6899 8.86001L15.4499 8.09001L16.2099 7.33001C17.0499 6.49001 17.0499 5.13001 16.2099 4.29001C16.0117 4.08803 15.7751 3.9276 15.5142 3.81808C15.2532 3.70856 14.973 3.65216 14.6899 3.65216C14.4069 3.65216 14.1267 3.70856 13.8657 3.81808C13.6048 3.9276 13.3682 4.08803 13.1699 4.29001L12.3999 5.05001L9.01995 8.43001C8.64995 6.99001 8.99995 5.41001 10.1199 4.29001L11.6399 2.76001C12.4498 1.95297 13.5466 1.49982 14.6899 1.49982C15.8333 1.49982 16.93 1.95297 17.7399 2.76001ZM8.58995 13.43L13.9299 8.09001C14.3499 7.67001 14.3499 6.99001 13.9299 6.57001C13.4899 6.14001 12.7999 6.18001 12.3999 6.57001L7.06995 11.91C6.64995 12.33 6.64995 13.01 7.06995 13.43C7.50995 13.86 8.19995 13.82 8.58995 13.43ZM7.82995 15.72L11.9699 11.57C12.3499 13.01 11.9999 14.59 10.8799 15.71L9.35995 17.24C8.55005 18.0471 7.4533 18.5002 6.30995 18.5002C5.1666 18.5002 4.06985 18.0471 3.25995 17.24C2.45291 16.4301 1.99976 15.3334 1.99976 14.19C1.99976 13.0467 2.45291 11.9499 3.25995 11.14L4.78995 9.62001C5.90995 8.50001 7.48995 8.15001 8.92995 8.52001L4.78995 12.67C3.93995 13.51 3.93995 14.87 4.78995 15.72C5.62995 16.56 6.98995 16.56 7.82995 15.72Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Direct Link Clients
                </NavLink>
              </li>
              <li className="">
                <Accordion.Item
                  className="border-0 bg-transparent"
                  eventKey="0"
                >
                  <Accordion.Header className="">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                      >
                        <mask
                          id="mask0_36_13"
                          style={{ maskType: "luminance" }}
                          maskUnits="userSpaceOnUse"
                          x="2"
                          y="2"
                          width="43"
                          height="43"
                        >
                          <path
                            d="M24 18C27.866 18 31 14.866 31 11C31 7.13401 27.866 4 24 4C20.134 4 17 7.13401 17 11C17 14.866 20.134 18 24 18Z"
                            fill="white"
                            stroke="white"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4 41C4 32.163 12.059 25 22 25"
                            stroke="white"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M34 43C38.9706 43 43 38.9706 43 34C43 29.0294 38.9706 25 34 25C29.0294 25 25 29.0294 25 34C25 38.9706 29.0294 43 34 43Z"
                            fill="white"
                            stroke="white"
                            stroke-width="4"
                          />
                          <path
                            d="M33 31V35H37"
                            stroke="black"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </mask>
                        <g mask="url(#mask0_36_13)">
                          <path d="M0 0H48V48H0V0Z" fill="white" />
                        </g>
                      </svg>
                    </span>{" "}
                    Appointment Scheduler
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ul className="ps-4 text-white m-0 py-2">
                      <li>
                        <NavLink
                          to="/help/scheduler/schedule-set-up"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Scheduler Set Up
                        </NavLink>
                      </li>
                      {/* <li>
                          <NavLink
                            to="/help/scheduler/appointment-Scheduler"
                            className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                          >
                            Appointment Scheduler
                          </NavLink>
                        </li> */}
                      <li>
                        <NavLink
                          to="/help/scheduler/appointment-page"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Appointment Page
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          to="/help/scheduler/book-appointment"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Booking an Appointment
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/scheduler/accept-payment"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Accepting Payments
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/scheduler/paying-appointment"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Paying for an Appointment
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/scheduler/appointment-Scheduler"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Cancelling & Refunding
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
              <li className="">
                <Accordion.Item
                  className="border-0 bg-transparent"
                  eventKey="1"
                >
                  <Accordion.Header className="">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M2 19C2 20.7 3.3 22 5 22H19C20.7 22 22 20.7 22 19V11H2V19ZM19 4H17V3C17 2.4 16.6 2 16 2C15.4 2 15 2.4 15 3V4H9V3C9 2.4 8.6 2 8 2C7.4 2 7 2.4 7 3V4H5C3.3 4 2 5.3 2 7V9H22V7C22 5.3 20.7 4 19 4Z"
                          fill="white"
                        />
                      </svg>
                    </span>{" "}
                    Google Calendar Integration
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ul className="ps-4 text-white m-0 py-2">
                      <li>
                        <NavLink
                          to="/help/google/link-account"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Linking your Account
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/google/appointment-syncing"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Appointment Syncing
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
              <li className="">
                <Accordion.Item
                  className="border-0 bg-transparent"
                  eventKey="2"
                >
                  <Accordion.Header className="">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1_2)">
                          <path
                            d="M10 3.5V11.5C10 12.0304 9.78929 12.5391 9.41421 12.9142C9.03914 13.2893 8.53043 13.5 8 13.5H0.5C1.03043 13.5 1.53914 13.2893 1.91421 12.9142C2.28929 12.5391 2.5 12.0304 2.5 11.5V2.5C2.5 1.96957 2.71071 1.46086 3.08579 1.08579C3.46086 0.710714 3.96957 0.5 4.5 0.5H11.75"
                            stroke="white"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6 4H7.5M5 7H7.5M5 10H7.5M11.75 0.5C12.2141 0.5 12.6592 0.684374 12.9874 1.01256C13.3156 1.34075 13.5 1.78587 13.5 2.25V3C13.5 3.13261 13.4473 3.25979 13.3536 3.35355C13.2598 3.44732 13.1326 3.5 13 3.5H10V2.25C10 1.78587 10.1844 1.34075 10.5126 1.01256C10.8408 0.684374 11.2859 0.5 11.75 0.5Z"
                            stroke="white"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1_2">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>{" "}
                    Fullscript Integeration
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ul className="ps-4 text-white m-0 py-2">
                      <li>
                        <NavLink
                          to="/help/fullscript/link-account"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Linking your Account
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/fullscript/link-clients"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Linking Clients
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/fullscript/create-recommendation"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Create a Recommendation
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/fullscript/naq-recommendation"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Recommendation from a NAQ
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/fullscript/client-orders"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Client Orders
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
              <li className="">
                <Accordion.Item
                  className="border-0 bg-transparent"
                  eventKey="3"
                >
                  <Accordion.Header className="">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <path
                          d="M5 6C3.355 6 2 7.355 2 9V23C2 24.645 3.355 26 5 26H27C28.645 26 30 24.645 30 23V9C30 7.355 28.645 6 27 6H5ZM5 8H27C27.565 8 28 8.435 28 9V23C28 23.565 27.565 24 27 24H5C4.435 24 4 23.565 4 23V9C4 8.435 4.435 8 5 8ZM16.5 11.438C16.3889 11.4367 16.2786 11.4575 16.1757 11.4994C16.0727 11.5413 15.9792 11.6033 15.9006 11.6819C15.8219 11.7604 15.7598 11.8539 15.7178 11.9567C15.6758 12.0596 15.6548 12.1699 15.656 12.281C15.656 12.751 16.026 13.127 16.5 13.127C16.6109 13.1273 16.7208 13.1056 16.8233 13.0633C16.9258 13.021 17.019 12.9588 17.0974 12.8804C17.1758 12.802 17.238 12.7088 17.2803 12.6063C17.3226 12.5038 17.3443 12.3939 17.344 12.283C17.3447 12.1721 17.3233 12.0621 17.2811 11.9595C17.2389 11.8569 17.1767 11.7638 17.0982 11.6854C17.0196 11.6071 16.9263 11.5451 16.8236 11.5032C16.7209 11.4612 16.6109 11.4401 16.5 11.441V11.438ZM11.062 12.188L9.688 12.406L9.5 13.626L9 13.719L8.812 14.842H9.5V17.186C9.5 17.796 9.65 18.208 9.97 18.466C10.235 18.681 10.617 18.779 11.156 18.779C11.572 18.779 11.826 18.701 12 18.655V17.405C11.903 17.431 11.68 17.468 11.53 17.468C11.213 17.468 11.063 17.305 11.063 16.935V14.841H11.906L12.094 13.621H11.064L11.062 12.184V12.188ZM6.907 13.53C6.361 13.53 5.889 13.672 5.564 13.938C5.226 14.216 5.064 14.638 5.064 15.125C5.064 16.008 5.594 16.369 6.47 16.688C7.034 16.888 7.22 17.028 7.22 17.25C7.22 17.464 7.05 17.594 6.72 17.594C6.31 17.594 5.63 17.384 5.188 17.124L5 18.344C5.377 18.559 6.085 18.782 6.813 18.782C7.391 18.782 7.863 18.668 8.188 18.408C8.552 18.122 8.75 17.672 8.75 17.128C8.75 16.224 8.203 15.851 7.312 15.533C6.838 15.359 6.562 15.248 6.562 15.033C6.562 14.853 6.702 14.723 6.969 14.723C7.454 14.723 7.966 14.928 8.311 15.097L8.498 13.877C7.99856 13.6452 7.45359 13.528 6.903 13.534L6.907 13.53ZM20.72 13.53C20.25 13.53 19.82 13.747 19.438 14.156L19.375 13.626H17.937V20.563L19.562 20.281V18.69C19.809 18.768 20.054 18.784 20.282 18.784C20.684 18.784 21.264 18.684 21.719 18.191C22.152 17.716 22.373 17.001 22.373 16.034C22.373 15.178 22.228 14.514 21.903 14.098C21.618 13.728 21.223 13.535 20.717 13.535L20.72 13.53ZM24.938 13.53C23.568 13.53 22.718 14.564 22.718 16.188C22.718 17.098 22.928 17.784 23.375 18.218C23.778 18.608 24.379 18.781 25.125 18.781C25.813 18.781 26.442 18.644 26.845 18.377L26.655 17.252C26.2335 17.4812 25.7608 17.5999 25.281 17.597C24.971 17.597 24.751 17.514 24.596 17.377C24.426 17.235 24.348 17.022 24.314 16.691H26.971C26.979 16.611 27.001 16.244 27.001 16.127C27.001 15.322 26.815 14.669 26.471 14.221C26.119 13.765 25.608 13.531 24.939 13.531L24.938 13.53ZM15 13.564C14.7857 13.5581 14.5753 13.6218 14.4004 13.7457C14.2255 13.8696 14.0955 14.0469 14.03 14.251L13.938 13.627H12.53V18.69H14.156V15.407C14.356 15.16 14.641 15.063 15.031 15.063C15.117 15.063 15.201 15.076 15.315 15.095V13.595C15.2122 13.5728 15.1071 13.5628 15.002 13.565L15 13.564ZM15.688 13.626V18.689H17.312V13.625L15.688 13.626ZM24.906 14.626C25.27 14.626 25.474 14.974 25.5 15.689H24.312C24.358 14.966 24.536 14.625 24.906 14.625V14.626ZM20.156 14.782C20.566 14.782 20.781 15.202 20.781 16.065C20.784 16.557 20.711 16.961 20.564 17.221C20.434 17.468 20.236 17.596 20.002 17.596C19.851 17.5987 19.7015 17.5666 19.565 17.502V15.097C19.838 14.811 20.069 14.784 20.159 14.784L20.156 14.782Z"
                          fill="white"
                        />
                      </svg>
                    </span>{" "}
                    Stripe Integration
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ul className="ps-4 text-white m-0 py-2">
                      <li>
                        <NavLink
                          to="/help/stripe/link-account"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Linking your Account
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/stripe/payment-method"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Payment Methods
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/stripe/incomplete-payment"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Incomplete Payments
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
              <li className="">
                <Accordion.Item
                  className="border-0 bg-transparent"
                  eventKey="4"
                >
                  <Accordion.Header className="">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <path
                          d="M5 6C3.355 6 2 7.355 2 9V23C2 24.645 3.355 26 5 26H27C28.645 26 30 24.645 30 23V9C30 7.355 28.645 6 27 6H5ZM5 8H27C27.565 8 28 8.435 28 9V23C28 23.565 27.565 24 27 24H5C4.435 24 4 23.565 4 23V9C4 8.435 4.435 8 5 8ZM16.5 11.438C16.3889 11.4367 16.2786 11.4575 16.1757 11.4994C16.0727 11.5413 15.9792 11.6033 15.9006 11.6819C15.8219 11.7604 15.7598 11.8539 15.7178 11.9567C15.6758 12.0596 15.6548 12.1699 15.656 12.281C15.656 12.751 16.026 13.127 16.5 13.127C16.6109 13.1273 16.7208 13.1056 16.8233 13.0633C16.9258 13.021 17.019 12.9588 17.0974 12.8804C17.1758 12.802 17.238 12.7088 17.2803 12.6063C17.3226 12.5038 17.3443 12.3939 17.344 12.283C17.3447 12.1721 17.3233 12.0621 17.2811 11.9595C17.2389 11.8569 17.1767 11.7638 17.0982 11.6854C17.0196 11.6071 16.9263 11.5451 16.8236 11.5032C16.7209 11.4612 16.6109 11.4401 16.5 11.441V11.438ZM11.062 12.188L9.688 12.406L9.5 13.626L9 13.719L8.812 14.842H9.5V17.186C9.5 17.796 9.65 18.208 9.97 18.466C10.235 18.681 10.617 18.779 11.156 18.779C11.572 18.779 11.826 18.701 12 18.655V17.405C11.903 17.431 11.68 17.468 11.53 17.468C11.213 17.468 11.063 17.305 11.063 16.935V14.841H11.906L12.094 13.621H11.064L11.062 12.184V12.188ZM6.907 13.53C6.361 13.53 5.889 13.672 5.564 13.938C5.226 14.216 5.064 14.638 5.064 15.125C5.064 16.008 5.594 16.369 6.47 16.688C7.034 16.888 7.22 17.028 7.22 17.25C7.22 17.464 7.05 17.594 6.72 17.594C6.31 17.594 5.63 17.384 5.188 17.124L5 18.344C5.377 18.559 6.085 18.782 6.813 18.782C7.391 18.782 7.863 18.668 8.188 18.408C8.552 18.122 8.75 17.672 8.75 17.128C8.75 16.224 8.203 15.851 7.312 15.533C6.838 15.359 6.562 15.248 6.562 15.033C6.562 14.853 6.702 14.723 6.969 14.723C7.454 14.723 7.966 14.928 8.311 15.097L8.498 13.877C7.99856 13.6452 7.45359 13.528 6.903 13.534L6.907 13.53ZM20.72 13.53C20.25 13.53 19.82 13.747 19.438 14.156L19.375 13.626H17.937V20.563L19.562 20.281V18.69C19.809 18.768 20.054 18.784 20.282 18.784C20.684 18.784 21.264 18.684 21.719 18.191C22.152 17.716 22.373 17.001 22.373 16.034C22.373 15.178 22.228 14.514 21.903 14.098C21.618 13.728 21.223 13.535 20.717 13.535L20.72 13.53ZM24.938 13.53C23.568 13.53 22.718 14.564 22.718 16.188C22.718 17.098 22.928 17.784 23.375 18.218C23.778 18.608 24.379 18.781 25.125 18.781C25.813 18.781 26.442 18.644 26.845 18.377L26.655 17.252C26.2335 17.4812 25.7608 17.5999 25.281 17.597C24.971 17.597 24.751 17.514 24.596 17.377C24.426 17.235 24.348 17.022 24.314 16.691H26.971C26.979 16.611 27.001 16.244 27.001 16.127C27.001 15.322 26.815 14.669 26.471 14.221C26.119 13.765 25.608 13.531 24.939 13.531L24.938 13.53ZM15 13.564C14.7857 13.5581 14.5753 13.6218 14.4004 13.7457C14.2255 13.8696 14.0955 14.0469 14.03 14.251L13.938 13.627H12.53V18.69H14.156V15.407C14.356 15.16 14.641 15.063 15.031 15.063C15.117 15.063 15.201 15.076 15.315 15.095V13.595C15.2122 13.5728 15.1071 13.5628 15.002 13.565L15 13.564ZM15.688 13.626V18.689H17.312V13.625L15.688 13.626ZM24.906 14.626C25.27 14.626 25.474 14.974 25.5 15.689H24.312C24.358 14.966 24.536 14.625 24.906 14.625V14.626ZM20.156 14.782C20.566 14.782 20.781 15.202 20.781 16.065C20.784 16.557 20.711 16.961 20.564 17.221C20.434 17.468 20.236 17.596 20.002 17.596C19.851 17.5987 19.7015 17.5666 19.565 17.502V15.097C19.838 14.811 20.069 14.784 20.159 14.784L20.156 14.782Z"
                          fill="white"
                        />
                      </svg>
                    </span>{" "}
                    Practice Better Integration
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ul className="ps-4 text-white m-0 py-2">
                      <li>
                        <NavLink
                          to="/help/practice/link-account"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Linking your Account
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/practice/sending-viewing-naqs"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Sending & Viewing NAQs
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
              <li className="">
                <NavLink
                  to="/help/my-doc"
                  className="text-white w-100 px-2 py-2 d-flex align-items-center"
                >
                  <span className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="white"
                      />
                      <path
                        d="M3 10V7H3.5C3.63261 7 3.75979 7.05268 3.85355 7.14645C3.94732 7.24021 4 7.36739 4 7.5V9.5C4 9.63261 3.94732 9.75979 3.85355 9.85355C3.75979 9.94732 3.63261 10 3.5 10H3ZM7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24021 7.05268 7.36739 7 7.5 7C7.63261 7 7.75979 7.05268 7.85355 7.14645C7.94732 7.24021 8 7.36739 8 7.5V9.5C8 9.63261 7.94732 9.75979 7.85355 9.85355C7.75979 9.94732 7.63261 10 7.5 10C7.36739 10 7.24021 9.94732 7.14645 9.85355C7.05268 9.75979 7 9.63261 7 9.5V7.5Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1 1.5C1 1.10218 1.15804 0.720644 1.43934 0.43934C1.72064 0.158035 2.10218 0 2.5 0L10.707 0L14 3.293V13.5C14 13.8978 13.842 14.2794 13.5607 14.5607C13.2794 14.842 12.8978 15 12.5 15H2.5C2.10218 15 1.72064 14.842 1.43934 14.5607C1.15804 14.2794 1 13.8978 1 13.5V1.5ZM3.5 6H2V11H3.5C3.89782 11 4.27936 10.842 4.56066 10.5607C4.84196 10.2794 5 9.89782 5 9.5V7.5C5 7.10218 4.84196 6.72064 4.56066 6.43934C4.27936 6.15804 3.89782 6 3.5 6ZM7.5 6C7.10218 6 6.72064 6.15804 6.43934 6.43934C6.15804 6.72064 6 7.10218 6 7.5V9.5C6 9.89782 6.15804 10.2794 6.43934 10.5607C6.72064 10.842 7.10218 11 7.5 11C7.89782 11 8.27936 10.842 8.56066 10.5607C8.84196 10.2794 9 9.89782 9 9.5V7.5C9 7.10218 8.84196 6.72064 8.56066 6.43934C8.27936 6.15804 7.89782 6 7.5 6ZM10 11V6H13V8H12V7H11V10H12V9H13V11H10Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  My Doc
                </NavLink>
              </li>
              <li className="">
                <NavLink
                  to="/help/my-form"
                  className="text-white w-100 px-2 py-2 d-flex align-items-center"
                >
                  <span className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="white"
                      />
                      <path
                        d="M3 10V7H3.5C3.63261 7 3.75979 7.05268 3.85355 7.14645C3.94732 7.24021 4 7.36739 4 7.5V9.5C4 9.63261 3.94732 9.75979 3.85355 9.85355C3.75979 9.94732 3.63261 10 3.5 10H3ZM7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24021 7.05268 7.36739 7 7.5 7C7.63261 7 7.75979 7.05268 7.85355 7.14645C7.94732 7.24021 8 7.36739 8 7.5V9.5C8 9.63261 7.94732 9.75979 7.85355 9.85355C7.75979 9.94732 7.63261 10 7.5 10C7.36739 10 7.24021 9.94732 7.14645 9.85355C7.05268 9.75979 7 9.63261 7 9.5V7.5Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1 1.5C1 1.10218 1.15804 0.720644 1.43934 0.43934C1.72064 0.158035 2.10218 0 2.5 0L10.707 0L14 3.293V13.5C14 13.8978 13.842 14.2794 13.5607 14.5607C13.2794 14.842 12.8978 15 12.5 15H2.5C2.10218 15 1.72064 14.842 1.43934 14.5607C1.15804 14.2794 1 13.8978 1 13.5V1.5ZM3.5 6H2V11H3.5C3.89782 11 4.27936 10.842 4.56066 10.5607C4.84196 10.2794 5 9.89782 5 9.5V7.5C5 7.10218 4.84196 6.72064 4.56066 6.43934C4.27936 6.15804 3.89782 6 3.5 6ZM7.5 6C7.10218 6 6.72064 6.15804 6.43934 6.43934C6.15804 6.72064 6 7.10218 6 7.5V9.5C6 9.89782 6.15804 10.2794 6.43934 10.5607C6.72064 10.842 7.10218 11 7.5 11C7.89782 11 8.27936 10.842 8.56066 10.5607C8.84196 10.2794 9 9.89782 9 9.5V7.5C9 7.10218 8.84196 6.72064 8.56066 6.43934C8.27936 6.15804 7.89782 6 7.5 6ZM10 11V6H13V8H12V7H11V10H12V9H13V11H10Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  My Form
                </NavLink>
              </li>
              <li className="">
                <Accordion.Item
                  className="border-0 bg-transparent"
                  eventKey="5"
                >
                  <Accordion.Header className="">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <path
                          d="M5 6C3.355 6 2 7.355 2 9V23C2 24.645 3.355 26 5 26H27C28.645 26 30 24.645 30 23V9C30 7.355 28.645 6 27 6H5ZM5 8H27C27.565 8 28 8.435 28 9V23C28 23.565 27.565 24 27 24H5C4.435 24 4 23.565 4 23V9C4 8.435 4.435 8 5 8ZM16.5 11.438C16.3889 11.4367 16.2786 11.4575 16.1757 11.4994C16.0727 11.5413 15.9792 11.6033 15.9006 11.6819C15.8219 11.7604 15.7598 11.8539 15.7178 11.9567C15.6758 12.0596 15.6548 12.1699 15.656 12.281C15.656 12.751 16.026 13.127 16.5 13.127C16.6109 13.1273 16.7208 13.1056 16.8233 13.0633C16.9258 13.021 17.019 12.9588 17.0974 12.8804C17.1758 12.802 17.238 12.7088 17.2803 12.6063C17.3226 12.5038 17.3443 12.3939 17.344 12.283C17.3447 12.1721 17.3233 12.0621 17.2811 11.9595C17.2389 11.8569 17.1767 11.7638 17.0982 11.6854C17.0196 11.6071 16.9263 11.5451 16.8236 11.5032C16.7209 11.4612 16.6109 11.4401 16.5 11.441V11.438ZM11.062 12.188L9.688 12.406L9.5 13.626L9 13.719L8.812 14.842H9.5V17.186C9.5 17.796 9.65 18.208 9.97 18.466C10.235 18.681 10.617 18.779 11.156 18.779C11.572 18.779 11.826 18.701 12 18.655V17.405C11.903 17.431 11.68 17.468 11.53 17.468C11.213 17.468 11.063 17.305 11.063 16.935V14.841H11.906L12.094 13.621H11.064L11.062 12.184V12.188ZM6.907 13.53C6.361 13.53 5.889 13.672 5.564 13.938C5.226 14.216 5.064 14.638 5.064 15.125C5.064 16.008 5.594 16.369 6.47 16.688C7.034 16.888 7.22 17.028 7.22 17.25C7.22 17.464 7.05 17.594 6.72 17.594C6.31 17.594 5.63 17.384 5.188 17.124L5 18.344C5.377 18.559 6.085 18.782 6.813 18.782C7.391 18.782 7.863 18.668 8.188 18.408C8.552 18.122 8.75 17.672 8.75 17.128C8.75 16.224 8.203 15.851 7.312 15.533C6.838 15.359 6.562 15.248 6.562 15.033C6.562 14.853 6.702 14.723 6.969 14.723C7.454 14.723 7.966 14.928 8.311 15.097L8.498 13.877C7.99856 13.6452 7.45359 13.528 6.903 13.534L6.907 13.53ZM20.72 13.53C20.25 13.53 19.82 13.747 19.438 14.156L19.375 13.626H17.937V20.563L19.562 20.281V18.69C19.809 18.768 20.054 18.784 20.282 18.784C20.684 18.784 21.264 18.684 21.719 18.191C22.152 17.716 22.373 17.001 22.373 16.034C22.373 15.178 22.228 14.514 21.903 14.098C21.618 13.728 21.223 13.535 20.717 13.535L20.72 13.53ZM24.938 13.53C23.568 13.53 22.718 14.564 22.718 16.188C22.718 17.098 22.928 17.784 23.375 18.218C23.778 18.608 24.379 18.781 25.125 18.781C25.813 18.781 26.442 18.644 26.845 18.377L26.655 17.252C26.2335 17.4812 25.7608 17.5999 25.281 17.597C24.971 17.597 24.751 17.514 24.596 17.377C24.426 17.235 24.348 17.022 24.314 16.691H26.971C26.979 16.611 27.001 16.244 27.001 16.127C27.001 15.322 26.815 14.669 26.471 14.221C26.119 13.765 25.608 13.531 24.939 13.531L24.938 13.53ZM15 13.564C14.7857 13.5581 14.5753 13.6218 14.4004 13.7457C14.2255 13.8696 14.0955 14.0469 14.03 14.251L13.938 13.627H12.53V18.69H14.156V15.407C14.356 15.16 14.641 15.063 15.031 15.063C15.117 15.063 15.201 15.076 15.315 15.095V13.595C15.2122 13.5728 15.1071 13.5628 15.002 13.565L15 13.564ZM15.688 13.626V18.689H17.312V13.625L15.688 13.626ZM24.906 14.626C25.27 14.626 25.474 14.974 25.5 15.689H24.312C24.358 14.966 24.536 14.625 24.906 14.625V14.626ZM20.156 14.782C20.566 14.782 20.781 15.202 20.781 16.065C20.784 16.557 20.711 16.961 20.564 17.221C20.434 17.468 20.236 17.596 20.002 17.596C19.851 17.5987 19.7015 17.5666 19.565 17.502V15.097C19.838 14.811 20.069 14.784 20.159 14.784L20.156 14.782Z"
                          fill="white"
                        />
                      </svg>
                    </span>{" "}
                    My Packages
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ul className="ps-4 text-white m-0 py-2">
                      <li>
                        <NavLink
                          to="/help/packages/create"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Creating a Package
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/packages/sending-purchasing"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Sending & Purchasing
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/packages/status"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Package Status
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
              <li className="">
                <NavLink
                  to="/help/naq-introduction"
                  className="text-white w-100 px-2 py-2 d-flex align-items-center"
                >
                  <span className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="white"
                      />
                      <path
                        d="M3 10V7H3.5C3.63261 7 3.75979 7.05268 3.85355 7.14645C3.94732 7.24021 4 7.36739 4 7.5V9.5C4 9.63261 3.94732 9.75979 3.85355 9.85355C3.75979 9.94732 3.63261 10 3.5 10H3ZM7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24021 7.05268 7.36739 7 7.5 7C7.63261 7 7.75979 7.05268 7.85355 7.14645C7.94732 7.24021 8 7.36739 8 7.5V9.5C8 9.63261 7.94732 9.75979 7.85355 9.85355C7.75979 9.94732 7.63261 10 7.5 10C7.36739 10 7.24021 9.94732 7.14645 9.85355C7.05268 9.75979 7 9.63261 7 9.5V7.5Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1 1.5C1 1.10218 1.15804 0.720644 1.43934 0.43934C1.72064 0.158035 2.10218 0 2.5 0L10.707 0L14 3.293V13.5C14 13.8978 13.842 14.2794 13.5607 14.5607C13.2794 14.842 12.8978 15 12.5 15H2.5C2.10218 15 1.72064 14.842 1.43934 14.5607C1.15804 14.2794 1 13.8978 1 13.5V1.5ZM3.5 6H2V11H3.5C3.89782 11 4.27936 10.842 4.56066 10.5607C4.84196 10.2794 5 9.89782 5 9.5V7.5C5 7.10218 4.84196 6.72064 4.56066 6.43934C4.27936 6.15804 3.89782 6 3.5 6ZM7.5 6C7.10218 6 6.72064 6.15804 6.43934 6.43934C6.15804 6.72064 6 7.10218 6 7.5V9.5C6 9.89782 6.15804 10.2794 6.43934 10.5607C6.72064 10.842 7.10218 11 7.5 11C7.89782 11 8.27936 10.842 8.56066 10.5607C8.84196 10.2794 9 9.89782 9 9.5V7.5C9 7.10218 8.84196 6.72064 8.56066 6.43934C8.27936 6.15804 7.89782 6 7.5 6ZM10 11V6H13V8H12V7H11V10H12V9H13V11H10Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  NAQ Introduction
                </NavLink>
              </li>
              <li className="">
                <Accordion.Item
                  className="border-0 bg-transparent"
                  eventKey="6"
                >
                  <Accordion.Header className="">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <path
                          d="M5 6C3.355 6 2 7.355 2 9V23C2 24.645 3.355 26 5 26H27C28.645 26 30 24.645 30 23V9C30 7.355 28.645 6 27 6H5ZM5 8H27C27.565 8 28 8.435 28 9V23C28 23.565 27.565 24 27 24H5C4.435 24 4 23.565 4 23V9C4 8.435 4.435 8 5 8ZM16.5 11.438C16.3889 11.4367 16.2786 11.4575 16.1757 11.4994C16.0727 11.5413 15.9792 11.6033 15.9006 11.6819C15.8219 11.7604 15.7598 11.8539 15.7178 11.9567C15.6758 12.0596 15.6548 12.1699 15.656 12.281C15.656 12.751 16.026 13.127 16.5 13.127C16.6109 13.1273 16.7208 13.1056 16.8233 13.0633C16.9258 13.021 17.019 12.9588 17.0974 12.8804C17.1758 12.802 17.238 12.7088 17.2803 12.6063C17.3226 12.5038 17.3443 12.3939 17.344 12.283C17.3447 12.1721 17.3233 12.0621 17.2811 11.9595C17.2389 11.8569 17.1767 11.7638 17.0982 11.6854C17.0196 11.6071 16.9263 11.5451 16.8236 11.5032C16.7209 11.4612 16.6109 11.4401 16.5 11.441V11.438ZM11.062 12.188L9.688 12.406L9.5 13.626L9 13.719L8.812 14.842H9.5V17.186C9.5 17.796 9.65 18.208 9.97 18.466C10.235 18.681 10.617 18.779 11.156 18.779C11.572 18.779 11.826 18.701 12 18.655V17.405C11.903 17.431 11.68 17.468 11.53 17.468C11.213 17.468 11.063 17.305 11.063 16.935V14.841H11.906L12.094 13.621H11.064L11.062 12.184V12.188ZM6.907 13.53C6.361 13.53 5.889 13.672 5.564 13.938C5.226 14.216 5.064 14.638 5.064 15.125C5.064 16.008 5.594 16.369 6.47 16.688C7.034 16.888 7.22 17.028 7.22 17.25C7.22 17.464 7.05 17.594 6.72 17.594C6.31 17.594 5.63 17.384 5.188 17.124L5 18.344C5.377 18.559 6.085 18.782 6.813 18.782C7.391 18.782 7.863 18.668 8.188 18.408C8.552 18.122 8.75 17.672 8.75 17.128C8.75 16.224 8.203 15.851 7.312 15.533C6.838 15.359 6.562 15.248 6.562 15.033C6.562 14.853 6.702 14.723 6.969 14.723C7.454 14.723 7.966 14.928 8.311 15.097L8.498 13.877C7.99856 13.6452 7.45359 13.528 6.903 13.534L6.907 13.53ZM20.72 13.53C20.25 13.53 19.82 13.747 19.438 14.156L19.375 13.626H17.937V20.563L19.562 20.281V18.69C19.809 18.768 20.054 18.784 20.282 18.784C20.684 18.784 21.264 18.684 21.719 18.191C22.152 17.716 22.373 17.001 22.373 16.034C22.373 15.178 22.228 14.514 21.903 14.098C21.618 13.728 21.223 13.535 20.717 13.535L20.72 13.53ZM24.938 13.53C23.568 13.53 22.718 14.564 22.718 16.188C22.718 17.098 22.928 17.784 23.375 18.218C23.778 18.608 24.379 18.781 25.125 18.781C25.813 18.781 26.442 18.644 26.845 18.377L26.655 17.252C26.2335 17.4812 25.7608 17.5999 25.281 17.597C24.971 17.597 24.751 17.514 24.596 17.377C24.426 17.235 24.348 17.022 24.314 16.691H26.971C26.979 16.611 27.001 16.244 27.001 16.127C27.001 15.322 26.815 14.669 26.471 14.221C26.119 13.765 25.608 13.531 24.939 13.531L24.938 13.53ZM15 13.564C14.7857 13.5581 14.5753 13.6218 14.4004 13.7457C14.2255 13.8696 14.0955 14.0469 14.03 14.251L13.938 13.627H12.53V18.69H14.156V15.407C14.356 15.16 14.641 15.063 15.031 15.063C15.117 15.063 15.201 15.076 15.315 15.095V13.595C15.2122 13.5728 15.1071 13.5628 15.002 13.565L15 13.564ZM15.688 13.626V18.689H17.312V13.625L15.688 13.626ZM24.906 14.626C25.27 14.626 25.474 14.974 25.5 15.689H24.312C24.358 14.966 24.536 14.625 24.906 14.625V14.626ZM20.156 14.782C20.566 14.782 20.781 15.202 20.781 16.065C20.784 16.557 20.711 16.961 20.564 17.221C20.434 17.468 20.236 17.596 20.002 17.596C19.851 17.5987 19.7015 17.5666 19.565 17.502V15.097C19.838 14.811 20.069 14.784 20.159 14.784L20.156 14.782Z"
                          fill="white"
                        />
                      </svg>
                    </span>{" "}
                    Food Logging Options
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ul className="ps-4 text-white m-0 py-2">
                      <li>
                        <NavLink
                          to="/help/food/fm-journal"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Food & Mood Journal
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/food/feeling-log"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Food & Feeling Log
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/help/food/logging-comparison"
                          className="text-white w-100 px-2 py-2 d-flex align-items-center bg-transparent"
                        >
                          Food Logging Comparison
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
              <li className="">
                <NavLink
                  to="/help/client-self-registeration"
                  className="text-white w-100 px-2 py-2 d-flex align-items-center"
                >
                  <span className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="white"
                      />
                      <path
                        d="M3 10V7H3.5C3.63261 7 3.75979 7.05268 3.85355 7.14645C3.94732 7.24021 4 7.36739 4 7.5V9.5C4 9.63261 3.94732 9.75979 3.85355 9.85355C3.75979 9.94732 3.63261 10 3.5 10H3ZM7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24021 7.05268 7.36739 7 7.5 7C7.63261 7 7.75979 7.05268 7.85355 7.14645C7.94732 7.24021 8 7.36739 8 7.5V9.5C8 9.63261 7.94732 9.75979 7.85355 9.85355C7.75979 9.94732 7.63261 10 7.5 10C7.36739 10 7.24021 9.94732 7.14645 9.85355C7.05268 9.75979 7 9.63261 7 9.5V7.5Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1 1.5C1 1.10218 1.15804 0.720644 1.43934 0.43934C1.72064 0.158035 2.10218 0 2.5 0L10.707 0L14 3.293V13.5C14 13.8978 13.842 14.2794 13.5607 14.5607C13.2794 14.842 12.8978 15 12.5 15H2.5C2.10218 15 1.72064 14.842 1.43934 14.5607C1.15804 14.2794 1 13.8978 1 13.5V1.5ZM3.5 6H2V11H3.5C3.89782 11 4.27936 10.842 4.56066 10.5607C4.84196 10.2794 5 9.89782 5 9.5V7.5C5 7.10218 4.84196 6.72064 4.56066 6.43934C4.27936 6.15804 3.89782 6 3.5 6ZM7.5 6C7.10218 6 6.72064 6.15804 6.43934 6.43934C6.15804 6.72064 6 7.10218 6 7.5V9.5C6 9.89782 6.15804 10.2794 6.43934 10.5607C6.72064 10.842 7.10218 11 7.5 11C7.89782 11 8.27936 10.842 8.56066 10.5607C8.84196 10.2794 9 9.89782 9 9.5V7.5C9 7.10218 8.84196 6.72064 8.56066 6.43934C8.27936 6.15804 7.89782 6 7.5 6ZM10 11V6H13V8H12V7H11V10H12V9H13V11H10Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Client Self-Registration
                </NavLink>
              </li>
              <li className="">
                <NavLink
                  to="/help/faq"
                  className="text-white w-100 px-2 py-2 d-flex align-items-center"
                >
                  <span className="icn me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="white"
                      />
                      <path
                        d="M3 10V7H3.5C3.63261 7 3.75979 7.05268 3.85355 7.14645C3.94732 7.24021 4 7.36739 4 7.5V9.5C4 9.63261 3.94732 9.75979 3.85355 9.85355C3.75979 9.94732 3.63261 10 3.5 10H3ZM7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24021 7.05268 7.36739 7 7.5 7C7.63261 7 7.75979 7.05268 7.85355 7.14645C7.94732 7.24021 8 7.36739 8 7.5V9.5C8 9.63261 7.94732 9.75979 7.85355 9.85355C7.75979 9.94732 7.63261 10 7.5 10C7.36739 10 7.24021 9.94732 7.14645 9.85355C7.05268 9.75979 7 9.63261 7 9.5V7.5Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1 1.5C1 1.10218 1.15804 0.720644 1.43934 0.43934C1.72064 0.158035 2.10218 0 2.5 0L10.707 0L14 3.293V13.5C14 13.8978 13.842 14.2794 13.5607 14.5607C13.2794 14.842 12.8978 15 12.5 15H2.5C2.10218 15 1.72064 14.842 1.43934 14.5607C1.15804 14.2794 1 13.8978 1 13.5V1.5ZM3.5 6H2V11H3.5C3.89782 11 4.27936 10.842 4.56066 10.5607C4.84196 10.2794 5 9.89782 5 9.5V7.5C5 7.10218 4.84196 6.72064 4.56066 6.43934C4.27936 6.15804 3.89782 6 3.5 6ZM7.5 6C7.10218 6 6.72064 6.15804 6.43934 6.43934C6.15804 6.72064 6 7.10218 6 7.5V9.5C6 9.89782 6.15804 10.2794 6.43934 10.5607C6.72064 10.842 7.10218 11 7.5 11C7.89782 11 8.27936 10.842 8.56066 10.5607C8.84196 10.2794 9 9.89782 9 9.5V7.5C9 7.10218 8.84196 6.72064 8.56066 6.43934C8.27936 6.15804 7.89782 6 7.5 6ZM10 11V6H13V8H12V7H11V10H12V9H13V11H10Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  FAQs
                </NavLink>
              </li>
            </ul>
          </div>
        </Accordion>
      </div>
    </>
  );
};

export default Sidebar;
